import UIButton from '@jetshop/ui/Button';
import styled, { css } from 'react-emotion';
import { Link } from 'react-router-dom';
import { theme } from '../Theme';

const SecondaryStyle = () => css`
  background-color: white;
  border-color: black;
  color: black;
`;

const TrendButtonStyle = ({ secondary, theme }) => css`
  background-color: #2f80ed;
  border-color: #2f80ed;
  color: white;
  ${theme.above.md} {
    max-width: 100%;
  }

  ${secondary && SecondaryStyle()};
`;

const Outline = css`
  background-color: transparent;
  border: 1px solid #2f80ed;
  color: #2f80ed;
`;

const Button = styled(UIButton)`
  font-family: ${theme.font.primary};
  text-transform: uppercase;
  width: ${({ widthAuto }) => (widthAuto ? 'auto' : '100%')};
  ${TrendButtonStyle};
  ${({ variant }) => {
    switch (variant) {
      case 'outline':
        return Outline;
      default:
        return null;
    }
  }}
`;

export const TrendLink = styled(Link)`
  ${TrendButtonStyle};
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
`;

export default Button;
